
define('text!modules/reporting/campaigns/dataExport/createEdit/templates/footerSpinner.html',[],function () { return '<strand-spinner radius="9" fill-color="#333333"></strand-spinner>\n';});

